import React from "react"
import PropTypes from "prop-types"

import MeetingListItem from '../meeting_sections/MeetingListItem'
import LoaderSection from '../app_components/LoaderSection'
import DashboardProfileCompletionSection from '../dashboard_sections/DashboardProfileCompletionSection'
import DashboardConnectsSection from '../dashboard_sections/DashboardConnectsSection'
import DashboardMatchesSection from '../dashboard_sections/DashboardMatchesSection'
import DashboardSectionShell from '../dashboard_sections/DashboardSectionShell'
import { isProfileIncomplete } from '../dashboard_sections/profileCompletionHelpers'

class UpcomingMeetingSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      matches: [],
      connectedUsers: [],
      meetings: [],
      profileCompletion: null,
      loading: true,
    }

    this.loadHomeData = this.loadHomeData.bind(this)
    this.getAllMeetings = this.getAllMeetings.bind(this)
    this.handleProfileUpdated = this.handleProfileUpdated.bind(this)
  }

  componentDidMount() {
    this.loadHomeData()
  }

  loadHomeData() {
    $.ajax({
      url: `../home_matches`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          matches: data.data.matches || [],
          connectedUsers: data.data.connected_users || [],
          meetings: JSON.parse(data.data.meetings),
          profileCompletion: data.data.profile_completion || null,
          loading: false,
        })
      },
      error: (xhr, status, err) => {
        console.log(err)
        this.setState({ loading: false })
      },
    })
  }

  handleProfileUpdated() {
    this.loadHomeData()
  }

  getAllMeetings() {
    $.ajax({
      url: `../getAllMeetings`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          meetings: JSON.parse(data.data.upcoming_meetings),
        })
      },
      error: (xhr, status, err) => {
        console.log(err)
      },
    })
  }

  renderUpcomingMeetings() {
    if (this.state.meetings.length === 0) {
      return null
    }

    return (
      <DashboardSectionShell
        icon="calendar"
        iconColor="#494CE9"
        title="Your Upcoming Lexes"
        subtitle="Scheduled language exchange sessions"
      >
        {this.state.meetings.map((meeting, i) => (
          <div key={meeting.id || i} className="dashboardUpcomingMeeting">
            <MeetingListItem
              item={meeting}
              currentUser={this.props.currentUser}
              getAllMeetings={this.getAllMeetings}
            />
          </div>
        ))}
      </DashboardSectionShell>
    )
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="dashboardHomeStack">
          <LoaderSection />
        </div>
      )
    }

    const showProfileCompletion = isProfileIncomplete(this.state.profileCompletion)
    const hasConnects = this.state.connectedUsers.length > 0
    const hasMatches = this.state.matches.length > 0
    const hasMeetings = this.state.meetings.length > 0
    const hasContent = showProfileCompletion || hasConnects || hasMatches || hasMeetings

    if (!hasContent) {
      return (
        <div className="dashboardHomeStack">
          <DashboardSectionShell
            icon="users-alt"
            iconSolid={false}
            title="Start connecting"
            subtitle="Complete your profile to find language partners."
          >
            <p className="dashboardHomeSection__emptyText">
              Add your profile details above to get matched with learners near you.
            </p>
          </DashboardSectionShell>
        </div>
      )
    }

    return (
      <div className="dashboardHomeStack">
        {this.renderUpcomingMeetings()}

        {showProfileCompletion && (
          <DashboardProfileCompletionSection
            profileCompletion={this.state.profileCompletion}
            onUpdated={this.handleProfileUpdated}
          />
        )}

        {hasConnects && (
          <DashboardConnectsSection
            connectedUsers={this.state.connectedUsers}
            currentUserId={this.props.currentUser.id}
            missingImg={this.props.missingImg}
          />
        )}

        {hasMatches && (
          <DashboardMatchesSection
            matches={this.state.matches}
            missingImg={this.props.missingImg}
          />
        )}
      </div>
    )
  }
}

UpcomingMeetingSection.propTypes = {
  currentUser: PropTypes.object,
  missingImg: PropTypes.string,
}

export default UpcomingMeetingSection
